import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { environment } from 'src/environments/environment';
import { CreateFundBookingInput, FundTypeEnum, EFundStatus, OpportunityItemDto, UpdateOpportunityTermsInput, ValidateInvestmentAmountInWalletInput, RedemptionMode } from '../../data-models/opportunity.data.models';
import { GeneralResponse, PaginatedList } from '../../data-models/shared.data-models';
import { GetMyInvestmentsOutputDto } from '../../data-models/investment.data.models';

@Injectable({
  providedIn: 'root'
})
export class FundDataService {

  private controllerUrl: string = `Fund/`;

  constructor(
    private baseApi: BaseApiService<any>,
  ) { }

  GetMyInvestmentsSummary(): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}GetMyInvestmentsSummary`);
  }
  GetMyInvestments(fundType?: FundTypeEnum | null): Observable<GeneralResponse<PaginatedList<GetMyInvestmentsOutputDto>>> {
    let fundTypeParam = fundType ? `?fundType=${fundType}` : '';
    return this.baseApi.Get(`${this.controllerUrl}GetMyInvestments${fundTypeParam}`);
  }
recoverMyInvestment(body: {
  opportunityId: string; 
  redemptionMode?: RedemptionMode;
  recoverUnitsCount?: number | null;
  recoverAmount?: number | null;
}): Observable<any> {
  return this.baseApi.Post(`${this.controllerUrl}CreateRecoverMyInvestmentRequest`, body);
}
  GetClosedFundRedemptionPreview(opportunityId: string): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}GetClosedFundRedemptionPreview?opportunityId=${opportunityId}`);
  }
  // Closed funds during the offering period: the server always redeems all units.
  RedeemAllClosedFundUnits(opportunityId: string): Observable<any> {
    return this.baseApi.Post(`${this.controllerUrl}CreateRecoverMyInvestmentRequest`, { opportunityId });
  }
  RecoverMyInvestmentRequest(opportunityId: string, recoverUnitsCount: number, investorSignature: string): Observable<any> {
    return this.baseApi.Post(`${this.controllerUrl}CreateRecoverMyInvestmentRequest`, { opportunityId, recoverUnitsCount, investorSignature });
  }
  GetAllOpportunities(fundStatusId?: EFundStatus | null,fundTypeId?:FundTypeEnum , pageIndex?: number, pageSize?: number): Observable<GeneralResponse<PaginatedList<OpportunityItemDto>>> {
    let fundTypeParam = fundStatusId != undefined ? `&fundStatusId=${fundStatusId}` : '';
    let fundTypeIdParam = fundTypeId != undefined ? `&fundTypeId=${fundTypeId}` : '';
    return this.baseApi.Get(`${this.controllerUrl}GetAllOpportunities?pageIndex=${pageIndex}&pageSize=${pageSize}${fundTypeParam}${fundTypeIdParam}`);
  }
  GetOpportunityDetails(opportunityId: string): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}GetOpportunityDetails?opportunityId=${opportunityId}`);
  }
  GetOpportunityBookingSummary(opportunityId: string): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}GetOpportunityBookingSummary?opportunityId=${opportunityId}`);
  }
  GetPrebookingFundReports(fundId: string): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}GetPrebookingFundReports?fundId=${fundId}`);
  }
  UpdateOpportunityTerms(body: UpdateOpportunityTermsInput): Observable<any> {
    return this.baseApi.Put(`${this.controllerUrl}UpdateOpportunityTerms`, body);
  }
  CreateFundBookingRequest(body: CreateFundBookingInput): Observable<any> {
    return this.baseApi.Post(`${this.controllerUrl}CreateFundBookingRequest`, body);
  }
  GetInvestmentFundReports(investmentFundId: string) {
    return this.baseApi.Get(`${this.controllerUrl}InvestmentFundReports?investmentFundId=${investmentFundId}`);

  }
  GetTermsAndConditions(fundId: string) {
    return this.baseApi.Get(`${this.controllerUrl}GetTermsAndConditions?fundId=${fundId}`);

  }
  ValidateInvestmentAmountInWallet(body: ValidateInvestmentAmountInWalletInput): Observable<any> {
    return this.baseApi.Post(`${this.controllerUrl}ValidateInvestmentAmountInWallet`, body);
  }
  GetFundValuationCycles(fundId: string, pageIndex: number, pageSize: number): Observable<any> {
    return this.baseApi.Get(`${this.controllerUrl}GetFundValuationCycles?FundId=${fundId}&PageIndex=${pageIndex}&PageSize=${pageSize}`);
  }
}
